import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/widget")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("campaigns.templates.widget.title"),
    })
  },
})
